import { FormField } from "components/form/FormField/FormField";
import { Select } from "components/ui/Select/Select";

import style from "../ReferralForm.module.css";

export const ReferralInfoFormSection = ({ form, isProstateReferral }) => {
  return (
    <div className={style.itemWrapper}>
      <div className={style.inputGroupGrid3Columns}>
        <FormField name="referralPriority">
          <label className={style.addReferralFormLabel}>
            Referral Priority *
          </label>
          <Select
            options={[
              {
                label: "Urgent",
                value: "URGENT",
              },
              {
                label: "Routine",
                value: "ROUTINE",
              },
            ]}
            value={form.watch("referralPriority")}
            onChange={(value) => form.setValue("referralPriority", value)}
            required
          />
        </FormField>
        {!isProstateReferral && (
          <FormField name="preferredConsultantFamilyName">
            <label className={style.addReferralFormLabel}>
              Preferred Consultant Family Name
            </label>
            <input
              type="text"
              className="form-control"
              {...form.register("preferredConsultantFamilyName")}
            />
          </FormField>
        )}
        {!isProstateReferral && (
          <FormField name="preferredConsultantFirstName">
            <label className={style.addReferralFormLabel}>
              Preferred Consultant First Name
            </label>
            <input
              type="text"
              className="form-control"
              {...form.register("preferredConsultantFirstName")}
            />
          </FormField>
        )}
        {!isProstateReferral && (
          <div style={{ gridColumn: "span 3" }}>
            <FormField name="reasonForReferral">
              <label className={style.addReferralFormLabel}>
                Reason for Referral / Anticipated Outcome <span>*</span>
              </label>
              <textarea
                className="form-control textareaform-control"
                style={{ minHeight: "126px" }}
                {...form.register("reasonForReferral")}
              />
            </FormField>
          </div>
        )}
      </div>
    </div>
  );
};
